import React from 'react';

interface BCPFormContainerProps {
  header?: React.ReactNode;
  alerts?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

const BCPFormContainer: React.FC<BCPFormContainerProps> = ({
  header,
  alerts,
  children,
  footer,
  className,
}) => {
  return (
    <div className={['space-y-6', className].filter(Boolean).join(' ')}>
      {header && (
        <div className="bg-white p-8 rounded-lg shadow-sm">
          {header}
        </div>
      )}

      {alerts}

      <div className="space-y-14">
        {children}
      </div>

      {footer}
    </div>
  );
};

export default BCPFormContainer;
